import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset the scroll position when the route changes.
 *
 * A single-page app keeps the window scroll across navigations, so opening a lesson from
 * the rail while halfway down a long one dropped you into the middle of the new lesson.
 * Keyed on pathname only: a query-string change (the search overlay) is not a new
 * document and should not throw the reader back to the top.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
